import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import Snackbar from "../../../../Snackbar";
import {Plus, X,} from 'lucide-react';
import RichTextEditor from "../../../UI/RichTextEditor";
import { createNewRichContent } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import RichContentCard from "./RichContentCard";
import UploaderAllCM from "../Uploader/UploaderAllCM";
import ImageWithFallback from "../../../UI/ImageFallBack";


import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";
import UniversalVideoPlayer from "../../CreateWebsite/VideoPlayer/UniversalVideoPlayerWebUI";
import PDFReaderCM from "../../../UI/PDFReaderCM";
  
const RichTextCardPopUp= ({hidePopUp,contentType, cardTitle, cardTitleColor,setRichTextPopUp,postParentId})=>{ 
    const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
        const [deleteTopicPopUp, setDeleteTopicPopUp] = useState(false);
        const [contentId, setContentId] = useState("");
         
      ;const handleDeleteRichContent=(contentId)=>{
             
             
             
             setLoader({status:true});
             
               const apiData = dispatch(createNewRichContent({contentId:contentId,
                           postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                           currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                           editType:"delete",appToken:AppToken,appId:appId}
                           ));
               /* get response as Promise   */
               apiData.then(response => {
                 if(response){     
                   setFireStatus(true)
               setTimeout(()=>{
                  setFireStatus(false)
                    
                 },100)
                   
                
                if(response?.logout){
                
                 setResponseMessage("You are Logged Out!!!");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 setTimeout(()=>{
                   dispatch({type:"LOGOUT"});
             
                 },3000)
                 
               }
             /* resetting Login input Fields */
             
                 }else{
                   setResponseMessage("Something Went Wrong...");
                   
                   setSnackbarColor("#958FDA");
                
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)    }
             
               }).catch(error => {
              
                 //popup of error Info
                 setResponseMessage("Something Went Wrong...");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 console.error(error);
               });
              
               }
      
       const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
                     const [isLoaded, setIsLoaded] = useState(false);
                     const [hasError, setHasError] = useState(false);
                     
                        
                             const [reloadItems, setReloadItems] = useState(true);
                            
                                useEffect(()=>{
                                    setReloadItems(false); setReloadItems(true);
                                    
                                },[ ])
                   
                                  
                     return (
                       <div style={{ position: "relative",boxShadow:boxShadow,
                       
                                   
                       maxWidth:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
                         {!isLoaded && !hasError && (
                           <div
                            style={
                                { 
                                   position: "relative",
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,
                          }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                           >
                             <img
                           src={loading_img}
                           alt=""
                         
                          style={
                                {
                                
                                   position: "relative",border:border,
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,padding:"10px",
                          }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                         />
                           </div>
                         )}
                         
                         <img
                   
                         
                           src={hasError ? fallback_img : src}
                           alt=""
                           onLoad={() => setIsLoaded(true)}
                           onError={() => setHasError(true)}
                          style={
                                {
                                   position: "relative",
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,
                          }}
                        
                         />
                       
                       </div>
                     );
                   };  
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
   

       const [content, setContent] = useState('');
       const [topicShow, setTopicShow] = useState('RichText');
       const [titleText, setTitleText] = useState('');
   const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
     const [currentTopic, setCurrentTopic] = useState({});
     const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
     const [currentFileType, setCurrentFileType] = useState({});
      
     const [itemArr, setItemArr] = useState([]);
      const [loader , setLoader] =useState({status:false});
     const[fireStatus,setFireStatus] =useState(false);
       useEffect(()=>{fireGetContentsByQuestionId()},[fireStatus])
         
  const fireGetContentsByQuestionId=()=>{
       setItemArrLoading([{},{},{},{}])
        setLoader({status:true});
        //  alert(postParentId)
          const apiData = dispatch(createNewRichContent({contentType:contentType,
            postParent:postParentId,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
            editType:"getAll",appToken:AppToken,appId:appId}
            ));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){   console.log(response)
              if(response?.contents){
                setItemArrLoading([])
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
         setItemArr(response?.contents);
         setTitleText(response?.contents[1]?.titleText)
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
           
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }
          const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
  
       const handleCreateNewRichContent=(fileType,currentFileObject)=>{
       let responseObject ;
       if(fileType==""){
      responseObject=  {contentType:contentType,mimeType:"",titleText:titleText,contentFormatedText:content,
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"create",appToken:AppToken,appId:appId}
       }
       if(fileType=="image"){
        responseObject=  {contentType:contentType,mimeType:"image",titleText:"",image_s3_key:currentFileObject?.file_s3_key,contentFormatedText:"",
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"create",appToken:AppToken,appId:appId}
       } if(fileType=="video"){
        responseObject=  {contentType:contentType,mimeType:"video",titleText:"",video_s3_key:currentFileObject?.file_s3_key,contentFormatedText:"",
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"create",appToken:AppToken,appId:appId}
       }
       if(fileType=="pdf"){
        responseObject=  {contentType:contentType,mimeType:"pdf",titleText:"",pdf_s3_key:currentFileObject?.file_s3_key,contentFormatedText:"",
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"create",appToken:AppToken,appId:appId}
       }
       
       
       setLoader({status:true});
       
         const apiData = dispatch(createNewRichContent(responseObject));
         /* get response as Promise   */
         apiData.then(response => {
           if(response){     
             if(response?.content){
             
           setResponseMessage(response?.message);
           setSnackbarColor("rgba(144, 202, 249,1)");
           setFireStatus(true)
         setTimeout(()=>{
            setFireStatus(false)
              setContent("")
           },100)
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
       },1000)
          }else{
           setResponseMessage("Something Went Wrong...");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
          }
             
          
          if(response?.logout){
          
           setResponseMessage("You are Logged Out!!!");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           setTimeout(()=>{
             dispatch({type:"LOGOUT"});
       
           },3000)
           
         }
       /* resetting Login input Fields */
       
           }else{
             setResponseMessage("Something Went Wrong...");
             
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)    }
       
         }).catch(error => {
        
           //popup of error Info
           setResponseMessage("Something Went Wrong...");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           console.error(error);
         });
        
         }
 
     return(<>
             
    <div style={{zIndex:99,}} > 
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 

     
   {!hidePopUp?<div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                        alignContent:"center",textAlign:"center",padding:"5px",paddingTop:"6px",margin:"5px",zIndex:99999,cursor:"pointer"}} onClick={()=>setRichTextPopUp()} ><X size={22}  color="rgb(86, 82, 131)"/></div> :""}
   <div style={{fontSize:"22px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"center"}}>
         {cardTitle} &nbsp;   <span className="coloredTextV1" >   {cardTitleColor}</span> </div>
               <div  className=" " style={{height:!hidePopUp?"83vh":"",overflowY:!hidePopUp?"auto":"",padding:"0px"}}>
  {/* <div  className="ikcraft_login-input-card" style={{margin:"0px"}} >
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Content Title`} type="text"
  rows={1} name="courseTitle" value={titleText} onChange={(e)=>{setTitleText(e.target.value)
     }} />
 </div>  */}
  {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.id}  style={{}}  >

            <div style={{padding:"10px"}}>      
   {item?.mimeType==""? <RichContentCard setFireStatus={(v)=>{setFireStatus(v)}}content={(item?.contentFormatedText)} contentId={item?.id}postParentId={postParentId} />:
   item?.mimeType=="image"?<div style={{position:"relative",padding:"10px"}}><style>{`.img-btns-outer { position: absolute;
          top: 10px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .img-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .img-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   <div className="img-btns-outer">
       <button className="img-btn" onClick={()=>{setDeleteTopicPopUp(true);setContentId(item?.id)}}>
          Delete Image
        </button> </div>
   
   <ImageFallFB src={item?.image_presigned_url} 
    border={{}}
                      width={ 100
                      }
                      aspectRatio={1}
                      borderRadius={ {}
                      }/>
                      
                      
                       {deleteTopicPopUp&&contentId==item?.id?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Item" type="deleteTopic"
       closePopUp={()=>{setDeleteTopicPopUp(false)}}
       onClickPopup={(type)=>{handleDeleteRichContent(item?.id);
        }}/>:""}</div>:item?.mimeType=="video"?<div style={{position:"relative",padding:"10px",marginTop:"50px"}}><style>{`.vid-btns-outer { position: absolute;
          top: -50px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .vid-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .vid-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   <div className="vid-btns-outer">
       <button className="vid-btn" onClick={()=>{handleDeleteRichContent(item?.id);}}>
          Delete Video
        </button> </div><UniversalVideoPlayer  videoSettings={{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"mp4URL",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           
                            videoThumbnail:{
                                src:"",hideThumbnail:true,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:50,resolution:"%"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }} videoUrl={item?.video_presigned_url} minHeight={450} maxHeight={450}/>
                                       {deleteTopicPopUp&&contentId==item?.id?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Item" type="deleteTopic"
       closePopUp={()=>{setDeleteTopicPopUp(false)}}
       onClickPopup={(type)=>{handleDeleteRichContent(item?.id);
        }}/>:""}</div>:item?.mimeType=="pdf"?<div style={{position:"relative",padding:"10px",marginTop:"50px"}}><style>{`.vid-btns-outer { position: absolute;
          top: -50px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .vid-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .vid-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   <div className="vid-btns-outer">
       <button className="vid-btn" onClick={()=>{setDeleteTopicPopUp(true);setContentId(item?.id)}}>
          Delete PDF
        </button> </div>

 <PDFReaderCM fileUrl={item?.pdf_presigned_url} />

                                       {deleteTopicPopUp&&contentId==item?.id?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Item" type="deleteTopic"
       closePopUp={()=>{setDeleteTopicPopUp(false)}}
       onClickPopup={(type)=>{handleDeleteRichContent(item?.id);
        }}/>:""}</div>:""}
     </div> </div>
  )):
  <></>:""}

           
    <div   style={{display:"flex",justifyContent:"center"
     }}> <div align="center">
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{marginTop:"15px",padding:"10px",}}>Add <span className="coloredTextV1"> New </span> Content</div>
      
       <div style={{width:"240px",display:"flex",justifyContent:"space-around",gap:"10px",margin:"10px"}}> 
           <div style={{border:topicShow=="RichText"?"3px solid #ffffff":"3px solid  rgba(144, 202, 249,1)",width:"40px",color:topicShow=="RichText"?"#ffffff":"#222222",background:topicShow=="RichText"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" , display:"flex",justifyContent:"center",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("RichText")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave}  
                  > Text</div>
                   <div style={{border:topicShow=="Image"?"3px solid #ffffff":"3px solid rgba(144, 202, 249,1)",width:"40px",color:topicShow=="Image"?"#ffffff":"#222222",background:topicShow=="Image"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" ,display:"flex",justifyContent:"center", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("Image")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  > Image</div>  <div style={{border:topicShow=="Video"?"3px solid #ffffff":"3px solid rgba(144, 202, 249,1)",width:"40px",color:topicShow=="Video"?"#ffffff":"#222222",background:topicShow=="Video"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" ,display:"flex",justifyContent:"center", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("Video")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  > Video</div>  <div style={{border:topicShow=="PDF"?"3px solid #ffffff":"3px solid rgba(144, 202, 249,1)",width:"40px",color:topicShow=="PDF"?"#ffffff":"#222222",background:topicShow=="PDF"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" ,display:"flex",justifyContent:"center", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("PDF")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  > PDF</div> 
                    {/* <div style={{border:topicShow=="FAQ"?"3px solid #ffffff":"3px solid rgba(144, 202, 249,1)",width:"40px",color:topicShow=="FAQ"?"#ffffff":"#222222",background:topicShow=="FAQ"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" ,display:"flex",justifyContent:"center", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("FAQ")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  > FAQ</div> */}
                  </div>
      </div>
     </div>
      <div style={{padding:"10px"}}>      
   <div style={{padding:"10px",position:"relative"}}>      
  {topicShow=="RichText"? <RichTextEditor value={content} onChange={setContent} />
  :topicShow=="Image"?<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div>{<ImageWithFallback src={""} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={28} setOpenFullImg={()=>{}}/>}
   </div> 
   
   
   
    <div>
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
   > Upload Image </button>
   </div>
   </div>
   :topicShow=="Video"?<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div>{<ImageWithFallback src={""} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={28} setOpenFullImg={()=>{}}/>}
   </div> 
   
   
   
    <div>
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);setCurrentFileType({ title: "Video", value: "video" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
   > Upload Video </button>
   </div>
   </div>
   :topicShow=="PDF"?<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div>{<ImageWithFallback src={""} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={28} setOpenFullImg={()=>{}}/>}
   </div> 
   
   
   
    <div>
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);setCurrentFileType({ title: "PDF", value: "pdf" })}}   className=" CoursesPreviewTopBtn" style={{marginTop:"20px",}}  type="submit"
   > Upload PDF </button>
   </div>
   </div>
   :topicShow=="FAQ"?"FAQ"
  :""}
  <div align="center" className="" style={{position:"relative",left:"0px",right:"0px",bottom:"-18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><div></div>
 {openUploaderPopUp && (
           <UploaderAllCM
             fileTypeObject={[currentFileType]}
             selectedFileObject={{}}
             currentFileObject={{}}
             setCurrentFileObject={(currentFileObject)=>{handleCreateNewRichContent(currentFileType?.value,currentFileObject)}}
             setCloseUploaderPopUp={() => setOpenUploaderPopUp(false)}
           />
         )}
 <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewRichContent("",{})}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {"Click To  Create"} </button>

</div> 
     </div>
     </div>
      </div>
     

       </div>  

  
      
                                    
     </>)  
   }
   export default RichTextCardPopUp;